import { render, staticRenderFns } from "./CardUpdateVideos.vue?vue&type=template&id=59773cef&scoped=true&"
import script from "./CardUpdateVideos.vue?vue&type=script&lang=js&"
export * from "./CardUpdateVideos.vue?vue&type=script&lang=js&"
import style0 from "./CardUpdateVideos.vue?vue&type=style&index=0&id=59773cef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59773cef",
  null
  
)

export default component.exports